<template>
    <span>
        <DaiCapaGeojsonHexbinDinamico 
        id="fauna_hexbin"
        :datos="todaFauna"
        :renderizarComoImagen="true"
        :reglas-estilo-capa="{
            columna:'features_count',
            clasificacion:'cortes-naturales',
            clases:3,
            colores:['#BFD083','#93BA86','#75A085']
        }"
        :diametroPixeles="20"
        :visible="faunaVerMalla && temasExpandidos['fauna']"
        :contenidoTooltip="tooltipMalla"
        ref="capa_hexbin"
        />
        
        
        <DaiCapaGeojsonCluster
        v-for="(capa,key) in capasPictogramas"
        :key="key+'_'+(cargadoPorPrimeraVez?'f':'n')"
        :id="capa.id"
        :datos="capa.datos"
        :visible="capa.visible"
        :renderizarComoImagen="true"
        :estilo-capa="capa.estilo"
        :z-index="8"
        :ref="capa.id"
        :contenidoTooltip="`Avistamiento de ${capa.nombre}`"
        />
        
    </span>
</template>

<script>
const ruta = process.env.VUE_APP_BASE_ROUTE === "/" ? "":process.env.VUE_APP_BASE_ROUTE

import {mapState} from "vuex"

export default {
    data(){
        return {
            todaFauna:{ "type": "FeatureCollection","features":[]},
            faunaPorTipo:{
                "aves":{ "type": "FeatureCollection","features":[]},
                "peces":{ "type": "FeatureCollection","features":[]},
                "reptiles":{ "type": "FeatureCollection","features":[]},
                "anfibios":{ "type": "FeatureCollection","features":[]},
                "mamiferos":{ "type": "FeatureCollection","features":[]}
            },
            capasPictogramas:{},
            cargadoPorPrimeraVez:false
        }
    },
    beforeMount(){
        this.llenarParametrosFaunaPorTipo()
        if(this.esteTemaActivo){
            this.cargadoInicialDeDatos()
        }

    },
    computed:{
        ...mapState('mapa',['faunaVerMalla','temasExpandidos','faunaTiposActivos','mapaEnMobile']),
        esteTemaActivo() {
            return this.temasExpandidos.fauna;
        },
        aves_visible:{
            get(){
                return this.$store.getters["mapa/esteTipoDeFaunaEstaActivo"]('aves') && this.temasExpandidos['fauna'] && !this.faunaVerMalla
            }
        },
        peces_visible:{
            get(){
                return this.$store.getters["mapa/esteTipoDeFaunaEstaActivo"]('peces') && this.temasExpandidos['fauna'] && !this.faunaVerMalla
            }
        },
        reptiles_visible:{
            get(){
                return this.$store.getters["mapa/esteTipoDeFaunaEstaActivo"]('reptiles') && this.temasExpandidos['fauna'] && !this.faunaVerMalla
            }
        },
        anfibios_visible:{
            get(){
                return this.$store.getters["mapa/esteTipoDeFaunaEstaActivo"]('anfibios') && this.temasExpandidos['fauna'] && !this.faunaVerMalla
            }
        },
        mamiferos_visible:{
            get(){
                return this.$store.getters["mapa/esteTipoDeFaunaEstaActivo"]('mamiferos') && this.temasExpandidos['fauna'] && !this.faunaVerMalla
            }
        }

    },
    methods:{
        llenarParametrosFaunaPorTipo(){
            /**Fauna por tipo ya se carga desde un estatico */

            /** Aqui solo se esta llenando los parametros de imagen y de visibilidad de cada tipo (5 iteraciones) */
            Object.keys(this.faunaPorTipo).forEach((key)=>{
                let params={
                    id:'fauna_'+key,
                    datos: this.faunaPorTipo[key],
                    estilo: {icon:{src:`./pictogramas/${key}.svg`}},
                    visible: this[key+'_visible'],
                    nombre:key
                }
                //console.log(params)
                //this.capasPictogramas.push(params)
                this.capasPictogramas[key] = params
            })
            
        },
        sumarFaunasSeleccionadas(){
            if(this.mapaEnMobile){
                return
            }
            // console.log("se estan sumando cosas en desktop")
            let sumatoria = []
            this.faunaTiposActivos.forEach(tipo=>{
                sumatoria = [...sumatoria,...this.faunaPorTipo[tipo].features]
            })
            
            this.todaFauna = { "type": "FeatureCollection","features":sumatoria}
        },
        tooltipMalla(f){
            const listaFaunas = this.faunaTiposActivos.join(", ")
            return `${f.features_count} puntos geográficos de avistamiento<br> de ${listaFaunas}`
        },
        tooltipPictogramas(f){
            return 
        },
        cargadoInicialDeDatos(){
          if(this.mapaEnMobile){
              return
          }
            const urlFaunaPorTipo = ruta + '/data/capasv2/06_fauna_por_tipo.json'
            
            this.$refs["capa_hexbin"].addLayerLoaderToQueue("carga_fauna1")
        
            fetch(urlFaunaPorTipo).then(responseTipos=>responseTipos.json()).then(dataTipos=>{
                this.faunaPorTipo = dataTipos;
                
                this.llenarParametrosFaunaPorTipo()
                //aqui se suman para la malla las faunas que estan seleccionadas, ahora ya no ocupamos , por el momento , todas las faunas juntas
                
                this.sumarFaunasSeleccionadas();
                
                this.cargadoPorPrimeraVez = true
                this.$refs["capa_hexbin"].removeLayerLoaderFromQueue("carga_fauna1")
            })
        }
    },
    watch:{
        faunaTiposActivos(nv,ov){
            if(this.faunaVerMalla){
                this.sumarFaunasSeleccionadas()
            }
            
        },
        faunaVerMalla(nv){
            if(nv){
                this.sumarFaunasSeleccionadas()
            }
        },
        aves_visible(nv){
            //console.log(nv,"se cambio aves, escuchado en watch")
            if(this.capasPictogramas['aves']){
                this.capasPictogramas['aves'].visible = nv
                this.$refs['fauna_aves'][0].olLayer.setVisible(nv)  
            }
            
            
        },
        peces_visible(nv){
            if(this.capasPictogramas['peces']){
                this.capasPictogramas['peces'].visible = nv
                this.$refs['fauna_peces'][0].olLayer.setVisible(nv)
            }
            
        },
        reptiles_visible(nv){
            if(this.capasPictogramas['reptiles']){
                this.capasPictogramas['reptiles'].visible = nv
                this.$refs['fauna_reptiles'][0].olLayer.setVisible(nv)
            }
            
        },
        anfibios_visible(nv){
            if(this.capasPictogramas['anfibios']){
                this.capasPictogramas['anfibios'].visible = nv
                this.$refs['fauna_anfibios'][0].olLayer.setVisible(nv)
            }
            
        },
        mamiferos_visible(nv){
            if(this.capasPictogramas['mamiferos']){
                this.capasPictogramas['mamiferos'].visible = nv
                this.$refs['fauna_mamiferos'][0].olLayer.setVisible(nv)
            }
            
        },
        esteTemaActivo(nuevoValor){
            if(!this.cargadoPorPrimeraVez){
                this.cargadoInicialDeDatos()
            }
        }
    },
}
</script>